export default __webpack_public_path__ + "static/media/gabinetOgm.b4348173.ogg";